import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.467.98H5.412v3.055h3.055V.98ZM14.484.283h-4.45v4.449h4.45V.282ZM19.3.786h-3.443v3.443H19.3V.786ZM3.239 6.208H0v3.238h3.239V6.208ZM12.69 7.396h-.862v.862h.862v-.862ZM19.814 5.592h-4.47v4.47h4.47v-4.47ZM7.442 12.644H6.436v1.006h1.006v-1.006ZM14.83 10.576H9.689v5.141h5.14v-5.14ZM4.304 5.328h5.208v5.208H4.304zM.604 12.18h2.604v2.604H.604z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.989 11.632h3.7v3.7h-3.7zM10.882 6.424h2.878v2.878h-2.878z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "navbar-logo"}) } }